import {datadogLogs} from '@datadog/browser-logs';

export function logDebug(message, messageContext = {}, error = {}) {
  datadogLogs.logger.debug(message, messageContext, error);
}

export function logInfo(message, messageContext = {}, error = {}) {
  datadogLogs.logger.info(message, messageContext, error);
}

export function logWarning(message, messageContext = {}, error = {}) {
  datadogLogs.logger.warn(message, messageContext, error);
}

export function logError(message, messageContext = {}, error = {}) {
  datadogLogs.logger.error(message, messageContext, error);
}